import { CalibrationType, HardwareListType, InventoryClass, InventoryControl, InventoryMethod, InventoryStatus, ItemMasterCategoryCode, LimitedLifeType, OrganizationType, Side } from '~/db_types';
import { GroundSupportEquipmentType, InventoryUnitType, ItemMasterPropertyClass, ReturnableStatus } from '~/db_types/swagger_types';
export const HardwareOrganizationTypeDisplay = new Map([
    [OrganizationType.GOVERNMENT, 'Government'],
    [OrganizationType.MANUFACTURER, 'Manufacturer'],
    [OrganizationType.PROCESSOR, 'Processor'],
    [OrganizationType.SUPPLIER, 'Supplier'],
    [OrganizationType.VENDOR, 'Vendor'],
    [OrganizationType.CONTRACTOR, 'Contractor']
]);
export const ItemMasterCategoryCodeDisplay = new Map([
    [ItemMasterCategoryCode.AB, 'AB: VBAs KERNCO'],
    [ItemMasterCategoryCode.BE, 'BE: BUSINESS EQUIPMENT'],
    [ItemMasterCategoryCode.CA, 'CA: ADHESIVES/CHEMICALS/TAPES'],
    [ItemMasterCategoryCode.CC, 'CC: CREW CLOTHING'],
    [ItemMasterCategoryCode.CD, 'CD: CEE-DAVID CLARK'],
    [ItemMasterCategoryCode.CE, 'CE: COMPUTER HARDWARE/SOFTWARE'],
    [ItemMasterCategoryCode.CH, 'CH: CEE HARDWARE'],
    [ItemMasterCategoryCode.CP, 'CP: CREW PREFERENCE'],
    [ItemMasterCategoryCode.CR, 'CR: CAMERA SERVICE/REPAIR'],
    [ItemMasterCategoryCode.CS, 'CS: CEE SERVICE/REPAIR'],
    [ItemMasterCategoryCode.DA, 'DA: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.DC, 'DC: CONTAINERS AND LABELS'],
    [ItemMasterCategoryCode.DD, 'DD: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.DS, 'DS: COMMUNICATION'],
    [ItemMasterCategoryCode.DT, 'DT: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.EE, 'EE: ELECTRICAL/ELECTRONIC ITEM_INSTANCES'],
    [ItemMasterCategoryCode.EH, 'EH: EMU HARDWARE'],
    [ItemMasterCategoryCode.EL, 'EL: ELECTROCHEM'],
    [ItemMasterCategoryCode.ES, 'ES: EMU SERVICE (SUB)'],
    [ItemMasterCategoryCode.FC, 'FC: FACILITIES MATERIAL AND EQUIPMENT'],
    [ItemMasterCategoryCode.FE, 'FE: FOOD EQUIPMENT'],
    [ItemMasterCategoryCode.FF, 'FF: FLIGHT FOOD'],
    [ItemMasterCategoryCode.FL, 'FL: FILM'],
    [ItemMasterCategoryCode.FS, 'FS: FASTENERS/SEALS/BEARINGS/PINS/CLAMPS'],
    [ItemMasterCategoryCode.GS, 'GS: COMPRESSED GASES, RECEIVABLES'],
    [ItemMasterCategoryCode.HF, 'HF: HOSE/TUBE/QD FITTINGS'],
    [ItemMasterCategoryCode.JH, 'JH: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.JP, 'JP: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.JS, 'JS: JANITORIAL SUPPLIES'],
    [ItemMasterCategoryCode.LS, 'LS: LAB/SAFETY/SHOP STOCK SUPPLIES'],
    [ItemMasterCategoryCode.LT, 'LT: TEST/LAB/COMMUNICATION EQUIPMENT'],
    [ItemMasterCategoryCode.MS, 'MS: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.NF, 'NF: NON-FCE'],
    [ItemMasterCategoryCode.NI, 'NI: NEEDS INPUT'],
    [ItemMasterCategoryCode.NL, 'NL: TO CLOSE OUT NANCY LEVIT POS'],
    [ItemMasterCategoryCode.OC, 'OC: OFFICE/COMPUTER/PRINTING SUPPLIES'],
    [ItemMasterCategoryCode.PR, 'PR: FCE PRINTING/BUSINESS FORMS'],
    [ItemMasterCategoryCode.PS, 'PS: CAMERA EQUIPMENT'],
    [ItemMasterCategoryCode.PT, 'PT: PAN TILT/CAMERA- LOCKHEED MARTIN'],
    [ItemMasterCategoryCode.RF, 'RF: RAW FOOD'],
    [ItemMasterCategoryCode.RM, 'RM: RAW MATERIALS'],
    [ItemMasterCategoryCode.SC, 'SC: COMPUTER SERVICE'],
    [ItemMasterCategoryCode.SD, 'SD: COMMUNICATION SERVICE/REPAIR'],
    [ItemMasterCategoryCode.SE, 'SE: EMU SERVICE/REPAIR'],
    [ItemMasterCategoryCode.SF, 'SF: FOOD SERVICE'],
    [ItemMasterCategoryCode.SG, 'SG: COMPRESSED GASES, SERVICES'],
    [ItemMasterCategoryCode.SL, 'SL: FACILITIES SERVICE/LABOR/MAINT/BLANKET ORDERS'],
    [ItemMasterCategoryCode.SP, 'SP: SERVICE, CREW PREFERENCE/CLOTHING,ETC.'],
    [ItemMasterCategoryCode.SR, 'SR: SERVICES/REPAIRS/VEHICLES'],
    [ItemMasterCategoryCode.SS, 'SS: SECURITY'],
    [ItemMasterCategoryCode.ST, 'ST: SERVICES, TEMPORARY/TRAVEL'],
    [ItemMasterCategoryCode.SV, 'SV: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.SW, 'SW: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.TA, 'TA: HAND/POWER TOOLS AND ACCESSORIES'],
    [ItemMasterCategoryCode.TB, 'TB: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.TR, 'TR: UNASSIGNED'],
    [ItemMasterCategoryCode.TS, 'TS: TOOL SUBASSEMBLIES AND ACCESSORIES'],
    [ItemMasterCategoryCode.TX, 'TX: TEXTILES'],
    [ItemMasterCategoryCode.UU, 'UU: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.WH, 'WH: ADMINSTRATIVE CODE'],
    [ItemMasterCategoryCode.WW, 'WW: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.XE, 'XE: XEMU HARDWARE'],
    [ItemMasterCategoryCode.ZA, 'ZA: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.ZB, 'ZB: ADMINISTRATIVE CATEGORY'],
    [ItemMasterCategoryCode.ZU, 'ZU: II'],
    [ItemMasterCategoryCode.ZZ, 'ZZ: ADMINISTRATIVE CATEGORY']
]);
export const AssetUsageCodeDisplay = new Map([
    ['_10ELEC', '10ELEC: 0-10.0 VOLT, ELECTRICAL'],
    ['_120ELEC', '120ELEC: 28.1-120 VOLT, ELECTRICAL'],
    ['_150AIR', '150AIR: 15.1-150 PSIG, AIR'],
    ['_150H2O', '150H2O: 15.1-150 PSIG, WATER'],
    ['_150INERT', '150INERT: 15.1-150 PSIG, INERT GAS'],
    ['_150O2', '150O2: 15.1-150 PSIG, OXYGEN'],
    ['_15AIR', '15AIR: 0-15 PSIG, AIR'],
    ['_15H2O', '15H2O: 0-15 PSIG, WATER'],
    ['_15INERT', '15INERT: 0-15 PSIG, INERT GAS'],
    ['_15O2', '15O2: 0-15 PSIG, OXYGEN'],
    ['_15VAC', '15VAC: 0-15 PSID, VACUUM'],
    ['_28ELEC', '28ELEC: 10.1-28 VOLT, ELECTRICAL'],
    ['_3000AIR', '3000AIR: 150.1-3000 PSIG, AIR'],
    ['_3000H2O', '3000H2O: 150.1-3000 PSIG, WATER'],
    ['_3000INERT', '3000INERT: 150.1-3000 PSIG, INERT GAS'],
    ['_3000O2', '3000O2: 150.1-3000 PSIG, OXYGEN'],
    ['_70LIFT', '70LIFT: 0-70 LB LIFTING EQUIPMENT'],
    ['_70SHIP', '70SHIP: 0-70 LB SHIPPING FIXTURE'],
    ['ALL', 'ALL: ITEMS IN THIS HDW CLASS'],
    ['FOOD', 'FOOD: FOOD PREPARATION'],
    ['GENEQ', 'GENEQ: NON-PRESS,NON-ELEC,NON-CRIT'],
    ['HDWCR', 'HDWCR: HDW,SCREWS,NUTS, CRITICAL'],
    ['HDWNC', 'HDWNC: HDW,SCREWS,NUTS, NON-CRITICAL'],
    ['UNLIMAIR', 'UNLIMAIR: 3001 PSIG & ABOVE, AIR'],
    ['UNLIMELEC', 'UNLIMELEC: 120.1 VOLT & ABOVE, ELECTRICAL'],
    ['UNLIMH2O', 'UNLIMH2O: 3001 PSIG & ABOVE, WATER'],
    ['UNLIMINERT', 'UNLIMINERT: 3001 PSIG & ABOVE, INERT GAS'],
    ['UNLIMLIFT', 'UNLIMLIFT: 70.1 LB & UP LIFTING EQUIPMENT'],
    ['UNLIMO2', 'UNLIMO2: 3001 PSIG & ABOVE, OXYGEN'],
    ['UNLIMSHIP', 'UNLIMSHIP: 70.1 LB & UP SHIPPING FIXTURE']
]);
export const AssetClassCodeDisplay = new Map([
    ['"A"', '"A": ALL; FLIGHT OR FLIGHT EQUIVALENT HARDWARE'],
    ['"B"', '"B": RED RISK ASSESSMENT; NON-FLIGHT ASSET'],
    ['"C"', '"C": YELLOW RISK ASSESSMENT; NON-FLIGHT ASSET'],
    ['"D"', '"D": GREEN RISK ASSESSMENT; NON-FLIGHT ASSET'],
    ['"N"', '"N": ASSET CLASS NOT APPLICABLE']
]);
export const ItemInstanceTypeToValidAssetClassCode = new Map([
    [InventoryClass.CLASS_I, ['A', 'N']],
    [InventoryClass.CLASS_II, ['A', 'N']],
    [InventoryClass.CLASS_III, ['B', 'C', 'D', 'N']],
    [InventoryClass.CLASS_IIIW, ['B', 'C', 'D', 'N']],
    [InventoryClass.GROUND_SUPPORT_EQUIPMENT, ['B', 'C', 'D', 'N']],
    [InventoryClass._PROTOTYPE, ['D', 'N']],
    [InventoryClass.PROGRAM_SUPPORT_EQUIPMENT, ['D', 'N']],
    [InventoryClass.PUBLIC_AFFAIRS_ONLY, ['D', 'N']],
    [InventoryClass.SPECIAL_TEST_EQUIPMENT, ['D', 'N']]
]);
export const AssetUsageCodeToValidAssetClassCode = new Map([
    [
        'UNLIMO2',
        [
            {
                classCode: 'B',
                isGseCritical: true
            }
        ]
    ],
    [
        '_3000O2',
        [
            {
                classCode: 'B',
                isGseCritical: true
            }
        ]
    ],
    [
        '_150O2',
        [
            {
                classCode: 'B',
                isGseCritical: true
            }
        ]
    ],
    [
        '_150O2',
        [
            {
                classCode: 'B',
                isGseCritical: true
            }
        ]
    ],
    [
        'UNLIMAIR',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_3000AIR',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_150AIR',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_15AIR',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        'UNLIMINERT',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_3000INERT',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_150INERT',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_15INERT',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_15O2',
        [
            {
                classCode: 'B',
                isGseCritical: true
            }
        ]
    ],
    [
        'UNLIMH2O',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_3000H2O',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_150H2O',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_15H2O',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_15VAC',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        'UNLIMELEC',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_120ELEC',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_28ELEC',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_10ELEC',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        'FOOD',
        [
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        'UNLIMLIFT',
        [
            {
                classCode: 'B',
                isGseCritical: true
            }
        ]
    ],
    [
        'UNLIMSHIP',
        [
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        '_70LIFT',
        [
            {
                classCode: 'B',
                isGseCritical: true
            },
            {
                classCode: 'C',
                isGseCritical: true
            }
        ]
    ],
    [
        '_70SHIP',
        [
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        'HDWCR',
        [
            {
                classCode: 'B',
                isGseCritical: true
            }
        ]
    ],
    [
        'HDWNC',
        [
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        'GENEQ',
        [
            {
                classCode: 'D',
                isGseCritical: false
            }
        ]
    ],
    [
        'ALL',
        [
            {
                classCode: 'B',
                isGseCritical: false
            },
            {
                classCode: 'A',
                isGseCritical: false
            },
            {
                classCode: 'C',
                isGseCritical: false
            },
            {
                classCode: 'D',
                isGseCritical: false
            },
            {
                classCode: 'N',
                isGseCritical: false
            }
        ]
    ]
]);
export const InventoryStatusDisplay = new Map([
    [InventoryStatus.IN_GRIEF, 'In Grief'],
    [InventoryStatus.IN_INVENTORY, 'In Inventory'],
    [InventoryStatus.IN_TRANSIT, 'In Transit'],
    [InventoryStatus.ISSUED, 'Issued'],
    [InventoryStatus.NEEDS_INSPECTION, 'Needs Inspection'],
    [InventoryStatus.NEEDS_TRANSFER, 'Needs Transfer'],
    [InventoryStatus.ON_DOCK, 'On Dock'],
    [InventoryStatus.REQUESTED, 'Requested']
]);
export const GroundSupportEquipmentTypeDisplay = new Map([
    [GroundSupportEquipmentType._2_KN_LOAD_CELL, '2 KN LOAD CELL'],
    [GroundSupportEquipmentType.AIR_FLOW_MONITOR, 'AIR FLOW MONITOR'],
    [GroundSupportEquipmentType.ALARM_PANEL, 'ALARM PANEL'],
    [GroundSupportEquipmentType.AMPLIFIER, 'AMPLIFIER'],
    [GroundSupportEquipmentType.ANALYZER, 'ANALYZER'],
    [GroundSupportEquipmentType.APFR_GSE_TETHER_ASSY, 'APFR GSE TETHER ASSY'],
    [GroundSupportEquipmentType.ATTENUATOR, 'ATTENUATOR'],
    [GroundSupportEquipmentType.BATTERY_CHARGER_DISCHARGER, 'BATTERY CHARGER DISCHARGER'],
    [GroundSupportEquipmentType.BATTERY_CHARGER_EMU_LIB, 'BATTERY CHARGER EMU LIB'],
    [GroundSupportEquipmentType.BATTERY_HITESTER, 'BATTERY HITESTER'],
    [GroundSupportEquipmentType.BLEED_FIXTURE, 'BLEED FIXTURE'],
    [GroundSupportEquipmentType.BREAKOUT_BOX, 'BREAKOUT BOX'],
    [GroundSupportEquipmentType.BUBBLE_FLOWMETER_KIT, 'BUBBLE FLOWMETER KIT'],
    [GroundSupportEquipmentType.CABLE, 'CABLE'],
    [GroundSupportEquipmentType.CALIBRATED_LEAK, 'CALIBRATED LEAK'],
    [GroundSupportEquipmentType.CALIPER, 'CALIPER'],
    [GroundSupportEquipmentType.CARRYING_FRAME, 'CARRYING FRAME'],
    [GroundSupportEquipmentType.CCC_SIMULATOR, 'CCC SIMULATOR'],
    [GroundSupportEquipmentType.CLEAN_ROOM_LSS, 'CLEAN ROOM LSS'],
    [GroundSupportEquipmentType.CLEAN_ROOM_SOP, 'CLEAN ROOM SOP'],
    [GroundSupportEquipmentType.CONTACT_TOOL, 'CONTACT TOOL'],
    [GroundSupportEquipmentType.COOLER, 'COOLER'],
    [GroundSupportEquipmentType.COUNTER, 'COUNTER'],
    [GroundSupportEquipmentType.CRIMP_TOOL, 'CRIMP TOOL'],
    [GroundSupportEquipmentType.CURRENT_METER, 'CURRENT METER'],
    [GroundSupportEquipmentType.DATA_ACQUISITION_UNIT, 'DATA ACQUISITION UNIT'],
    [GroundSupportEquipmentType.DECADE_RESISTOR, 'DECADE RESISTOR'],
    [GroundSupportEquipmentType.DESKTOP_COMPUTER, 'DESKTOP COMPUTER'],
    [GroundSupportEquipmentType.DIA_PUMP, 'DIA PUMP'],
    [GroundSupportEquipmentType.DIAL_CHAMFER_GAUGE, 'DIAL CHAMFER GAUGE'],
    [GroundSupportEquipmentType.DIGITAL_LEVEL, 'DIGITAL LEVEL'],
    [GroundSupportEquipmentType.DIT_MCO_2_CABLE_TEST_SYSTEM_ASSEMBLY, 'DIT MCO 2 CABLE TEST SYSTEM ASSEMBLY'],
    [GroundSupportEquipmentType.ELECTRICAL_GLOVES, 'ELECTRICAL GLOVES'],
    [GroundSupportEquipmentType.ELECTRONIC_LOAD, 'ELECTRONIC LOAD'],
    [GroundSupportEquipmentType.EMU_DISPLAY_STAND_ASSY, 'EMU DISPLAY STAND ASSY'],
    [GroundSupportEquipmentType.EMU_GROUND_TEST_FIXTURE_FRAME, 'EMU GROUND TEST FIXTURE FRAME'],
    [GroundSupportEquipmentType.EMU_GROUND_TEST_FIXTURE, 'EMU GROUND TEST FIXTURE'],
    [GroundSupportEquipmentType.EMU_LIFTING_FIXTURE, 'EMU LIFTING FIXTURE'],
    [GroundSupportEquipmentType.EMU_OFFSET_HOLDING_FIXTURE, 'EMU OFFSET HOLDING FIXTURE'],
    [GroundSupportEquipmentType.EQUIPMENT_TBD, 'EQUIPMENT TBD'],
    [GroundSupportEquipmentType.FACILITY_B_A_SYSTEM, 'FACILITY "B" "A" SYSTEM'],
    [GroundSupportEquipmentType.FACILITY_BA_SYSTEM, 'FACILITY BA SYSTEM'],
    [GroundSupportEquipmentType.FACILITY_DA_SYSTEM, 'FACILITY DA SYSTEM'],
    [GroundSupportEquipmentType.FACILITY_H20_SYSTEM, 'FACILITY H20 SYSTEM'],
    [GroundSupportEquipmentType.FACILITY_H2O_SYSTEM, 'FACILITY H2O SYSTEM'],
    [GroundSupportEquipmentType.FACILITY_N2_SYSTEM, 'FACILITY N2 SYSTEM'],
    [GroundSupportEquipmentType.FACILITY_O2_SYSTEM, 'FACILITY O2 SYSTEM'],
    [GroundSupportEquipmentType.FC_FLOW_CONTROLLER, 'FC FLOW CONTROLLER'],
    [GroundSupportEquipmentType.FCD_FLOW_CONTROL_DISPLAY, 'FCD FLOW CONTROL DISPLAY'],
    [GroundSupportEquipmentType.FILTER, 'FILTER'],
    [GroundSupportEquipmentType.FIXTURE, 'FIXTURE'],
    [GroundSupportEquipmentType.FLEXHOSE, 'FLEXHOSE'],
    [GroundSupportEquipmentType.FLOW_BENCH, 'FLOW BENCH'],
    [GroundSupportEquipmentType.FLOWMETER, 'FLOWMETER'],
    [GroundSupportEquipmentType.FORCE_GAUGE, 'FORCE GAUGE'],
    [GroundSupportEquipmentType.FORK_HOOK, 'FORK HOOK'],
    [GroundSupportEquipmentType.FORKLIFT, 'FORKLIFT'],
    [GroundSupportEquipmentType.FT_FLOW_TRANSDUCER, 'FT FLOW TRANSDUCER'],
    [GroundSupportEquipmentType.FTD_FLOW_TRANSDUCER_DISPLAY, 'FTD FLOW TRANSDUCER DISPLAY'],
    [GroundSupportEquipmentType.FUME_HOOD, 'FUME HOOD'],
    [GroundSupportEquipmentType.FUNCTION_GENERATOR, 'FUNCTION GENERATOR'],
    [GroundSupportEquipmentType.GAGE_ACTIVE_WIF_PROBE, 'GAGE ACTIVE WIF PROBE'],
    [GroundSupportEquipmentType.GHD_HOISTING_SLING, 'GHD HOISTING SLING'],
    [GroundSupportEquipmentType.GLOVE_MEASURE_DEVICE, 'GLOVE MEASURE DEVICE'],
    [GroundSupportEquipmentType.GLUE_BENCH, 'GLUE BENCH'],
    [GroundSupportEquipmentType.GO_GAGE, 'GO GAGE'],
    [GroundSupportEquipmentType.GO_NO_GO_GAUGE, 'GO NO GO GAUGE'],
    [GroundSupportEquipmentType.GROUND_HANDLING_DEVICE, 'GROUND HANDLING DEVICE'],
    [GroundSupportEquipmentType.HEIGHT_EXTENDER_ASSY, 'HEIGHT EXTENDER ASSY'],
    [GroundSupportEquipmentType.HELIUM_LEAK_PROBE, 'HELIUM LEAK PROBE'],
    [GroundSupportEquipmentType.HIGH_POT_TESTER, 'HIGH POT TESTER'],
    [GroundSupportEquipmentType.HIGH_RESISTANCE_METER, 'HIGH RESISTANCE METER'],
    [GroundSupportEquipmentType.HOIST, 'HOIST'],
    [GroundSupportEquipmentType.HOSE_ASSEMBLY, 'HOSE ASSEMBLY'],
    [GroundSupportEquipmentType.HOSE_SWAGING_CART, 'HOSE SWAGING CART'],
    [GroundSupportEquipmentType.HYGRO_THERMOMETER, 'HYGRO THERMOMETER'],
    [GroundSupportEquipmentType.IMPACT_O_GRAPH, 'IMPACT O GRAPH'],
    [GroundSupportEquipmentType.IONIZER, 'IONIZER'],
    [GroundSupportEquipmentType.IR_THERMOMETER, 'IR THERMOMETER'],
    [GroundSupportEquipmentType.LAB_TOP_COMPUTER, 'LAB TOP COMPUTER'],
    [GroundSupportEquipmentType.LAUNCH_ENCLOSURE_LIFTING_EYE, 'LAUNCH ENCLOSURE LIFTING EYE'],
    [GroundSupportEquipmentType.LIFTING_BEAM, 'LIFTING BEAM'],
    [GroundSupportEquipmentType.LIFTING_FIXTURE, 'LIFTING FIXTURE'],
    [GroundSupportEquipmentType.LIFTING_STRAP, 'LIFTING STRAP'],
    [GroundSupportEquipmentType.LTA_SUSPENSION_ALIGNMENT_FIXTURE, 'LTA SUSPENSION ALIGNMENT FIXTURE'],
    [GroundSupportEquipmentType.MAN_LIFT, 'MAN LIFT'],
    [GroundSupportEquipmentType.MEASURING_TAPE, 'MEASURING TAPE'],
    [GroundSupportEquipmentType.MERCURY_VAPOR_ANALYZER, 'MERCURY VAPOR ANALYZER'],
    [GroundSupportEquipmentType.MICROMETER, 'MICROMETER'],
    [GroundSupportEquipmentType.MODULATION_METER, 'MODULATION METER'],
    [GroundSupportEquipmentType.MOISTURE_MONITOR, 'MOISTURE MONITOR'],
    [GroundSupportEquipmentType.MONITOR_GROUND, 'MONITOR GROUND'],
    [GroundSupportEquipmentType.MOUNTING_FRAME, 'MOUNTING FRAME'],
    [GroundSupportEquipmentType.MULITPLE_WATER_CONNECTOR, 'MULTIPLE WATER CONNECTOR'],
    [GroundSupportEquipmentType.MULTIMETER, 'MULTIMETER'],
    [GroundSupportEquipmentType.MULTIPLE_WATER_CONNECTOR_, 'MULTIPLE WATER CONNECTOR '],
    [GroundSupportEquipmentType.MULTITESTER, 'MULTITESTER'],
    [GroundSupportEquipmentType.NECK_PLATE_INTERFACE_FIXTURE, 'NECK PLATE INTERFACE FIXTURE'],
    [GroundSupportEquipmentType.O2_MONITOR, 'O2 MONITOR'],
    [GroundSupportEquipmentType.OHMMETER, 'OHMMETER'],
    [GroundSupportEquipmentType.OSCILLATOR, 'OSCILLATOR'],
    [GroundSupportEquipmentType.OSCILLOSCOPE, 'OSCILLOSCOPE'],
    [GroundSupportEquipmentType.OVEN, 'OVEN'],
    [GroundSupportEquipmentType.PALLET_JACK, 'PALLET JACK'],
    [GroundSupportEquipmentType.PANEL_METER, 'PANEL METER'],
    [GroundSupportEquipmentType.PARTICLE_COUNTER, 'PARTICLE COUNTER'],
    [GroundSupportEquipmentType.PH_METER, 'PH METER'],
    [GroundSupportEquipmentType.PIN_RETENTION_TOOL, 'PIN RETENTION TOOL'],
    [GroundSupportEquipmentType.PLATE_MILLIOHM_REFERENCE, 'PLATE MILLIOHM REFERENCE'],
    [GroundSupportEquipmentType.PLSS_WEIGHT_BOX, 'PLSS WEIGHT BOX'],
    [GroundSupportEquipmentType.POWER_SUPPLY, 'POWER SUPPLY'],
    [GroundSupportEquipmentType.PRESSURE_GAUGE, 'PRESSURE GAUGE'],
    [GroundSupportEquipmentType.PRESSURE_REGULATOR, 'PRESSURE REGULATOR'],
    [GroundSupportEquipmentType.PRESSURE_SWITCH, 'PRESSURE SWITCH'],
    [GroundSupportEquipmentType.PROBE, 'PROBE'],
    [GroundSupportEquipmentType.PT_PRESSURE_TRANSDUCER, 'PT PRESSURE TRANSDUCER'],
    [GroundSupportEquipmentType.PTD_PRESSURE_TRANSDUCER_DISPLAY, 'PTD PRESSURE TRANSDUCER DISPLAY'],
    [GroundSupportEquipmentType.RADIO_TEST_SET, 'RADIO TEST SET'],
    [GroundSupportEquipmentType.RECEIVER, 'RECEIVER'],
    [GroundSupportEquipmentType.RECORDERS, 'RECORDERS'],
    [GroundSupportEquipmentType.REGULATOR, 'REGULATOR'],
    [GroundSupportEquipmentType.RELIEF_VALVE, 'RELIEF VALVE'],
    [GroundSupportEquipmentType.SAMPLE_CYLINDER, 'SAMPLE CYLINDER'],
    [GroundSupportEquipmentType.SCALE, 'SCALE'],
    [GroundSupportEquipmentType.SEMU_LIFTING_BAR_ASSY, 'SEMU LIFTING BAR ASSY'],
    [GroundSupportEquipmentType.SENSOR_MODULE, 'SENSOR MODULE'],
    [GroundSupportEquipmentType.SHACKLE, 'SHACKLE'],
    [GroundSupportEquipmentType.SHIPPING_CONTAINER, 'SHIPPING CONTAINER'],
    [GroundSupportEquipmentType.SHUCK_TEST_MICROMETER_GAUGE_ASSY, 'SHUCK TEST MICROMETER GAUGE ASSY'],
    [GroundSupportEquipmentType.SOLDERING_STATION, 'SOLDERING STATION'],
    [GroundSupportEquipmentType.SOUND_LEVEL_CALIBRATOR, 'SOUND LEVEL CALIBRATOR'],
    [GroundSupportEquipmentType.SOUND_LEVEL_METER, 'SOUND LEVEL METER'],
    [GroundSupportEquipmentType.SOUND_PRESSURE_METER, 'SOUND PRESSURE METER'],
    [GroundSupportEquipmentType.STATIC_LOCATOR, 'STATIC LOCATOR'],
    [GroundSupportEquipmentType.SUPPORT_PLATFORM_EMU_ADJUSTIBLE_HEIGHT, 'SUPPORT PLATFORM EMU ADJUSTIBLE HEIGHT'],
    [GroundSupportEquipmentType.SURFACE_RESIST_IND, 'SURFACE RESIST IND'],
    [GroundSupportEquipmentType.SURFACE_RESISTIVITY_METER, 'SURFACE RESISTIVITY METER'],
    [GroundSupportEquipmentType.TD_TEMPERATURE_DISPLAY, 'TD TEMPERATURE DISPLAY'],
    [GroundSupportEquipmentType.TEMP_HUMIDITY_RECORDER, 'TEMP HUMIDITY RECORDER'],
    [GroundSupportEquipmentType.TEMPERATURE_CONTROLLER, 'TEMPERATURE CONTROLLER'],
    [GroundSupportEquipmentType.TEMPERATURE_LIMIT_CONTROLLER, 'TEMPERATURE LIMIT CONTROLLER'],
    [GroundSupportEquipmentType.TEMPERATURE_RECORDER, 'TEMPERATURE RECORDER'],
    [GroundSupportEquipmentType.TEST_STAND, 'TEST STAND'],
    [GroundSupportEquipmentType.THERMOCOUPLE_DISPLAY, 'THERMOCOUPLE DISPLAY'],
    [GroundSupportEquipmentType.THERMOMETER, 'THERMOMETER'],
    [GroundSupportEquipmentType.TIMER_CLOCK, 'TIMER CLOCK'],
    [GroundSupportEquipmentType.TIMER, 'TIMER'],
    [GroundSupportEquipmentType.TORQUE_DRIVER, 'TORQUE DRIVER'],
    [GroundSupportEquipmentType.TORQUE_METER, 'TORQUE METER'],
    [GroundSupportEquipmentType.TORQUE_TESTER, 'TORQUE TESTER'],
    [GroundSupportEquipmentType.TORQUE_TRANSDUCER, 'TORQUE TRANSDUCER'],
    [GroundSupportEquipmentType.TORQUE_WRENCH, 'TORQUE WRENCH'],
    [GroundSupportEquipmentType.TT_TEMPERATURE_TRANSMITTER, 'TT TEMPERATURE TRANSMITTER'],
    [GroundSupportEquipmentType.VACUUM_CHAMBER_ASSY_22_LITER, 'VACUUM CHAMBER ASSY 22 LITER'],
    [GroundSupportEquipmentType.VACUUM_DISPLAY, 'VACUUM DISPLAY'],
    [GroundSupportEquipmentType.VACUUM_OVEN, 'VACUUM OVEN'],
    [GroundSupportEquipmentType.VACUUM_PUMP, 'VACUUM PUMP'],
    [GroundSupportEquipmentType.VACUUM_SENSOR, 'VACUUM SENSOR'],
    [GroundSupportEquipmentType.VEHICLE_BOBTAIL_TRUCK, 'VEHICLE BOBTAIL TRUCK'],
    [GroundSupportEquipmentType.VELOCITY_METER, 'VELOCITY METER'],
    [GroundSupportEquipmentType.VENT_HOOD, 'VENT HOOD'],
    [GroundSupportEquipmentType.VITAL_SIGNS_SIMILATOR, 'VITAL SIGNS SIMILATOR'],
    [GroundSupportEquipmentType.VOLTMETER, 'VOLTMETER'],
    [GroundSupportEquipmentType.VRMS_METER, 'VRMS METER'],
    [GroundSupportEquipmentType.WATER_CONNECTOR_AIRLOCK, 'WATER CONNECTOR AIRLOCK'],
    [GroundSupportEquipmentType.WATER_TANK, 'WATER TANK'],
    [GroundSupportEquipmentType.WATER_TRAP, 'WATER TRAP'],
    [GroundSupportEquipmentType.WAVEFORM_GENERATOR, 'WAVEFORM GENERATOR'],
    [GroundSupportEquipmentType.WAVEFORM_MONITOR, 'WAVEFORM MONITOR'],
    [GroundSupportEquipmentType.WEIGHT_BOX, 'WEIGHT BOX'],
    [GroundSupportEquipmentType.WELD_EXHAUST_HOOD, 'WELD EXHAUST HOOD'],
    [GroundSupportEquipmentType.WIRE_CRIMPER, 'WIRE CRIMPER'],
    [GroundSupportEquipmentType.WIRE_STRIPPER, 'WIRE STRIPPER'],
    [GroundSupportEquipmentType.WRIST_STRAP_FOOTWEAR_CHECKER, 'WRIST STRAP FOOTWEAR CHECKER'],
    [GroundSupportEquipmentType.X_RAY_MACHINE, 'X RAY MACHINE']
]);
export var HardwareListNote;
(function (HardwareListNote) {
    HardwareListNote["ONE"] = "1";
    HardwareListNote["TWO"] = "2";
    HardwareListNote["THREE"] = "3";
    HardwareListNote["FOUR"] = "4";
    HardwareListNote["FIVE"] = "5";
    HardwareListNote["SIX"] = "6";
    HardwareListNote["SEVEN"] = "7";
    HardwareListNote["EIGHT"] = "8";
    HardwareListNote["NINE"] = "9";
    HardwareListNote["TEN"] = "10";
    HardwareListNote["ELEVEN"] = "11";
    HardwareListNote["TWELVE"] = "12";
    HardwareListNote["THIRTEEN"] = "13";
    HardwareListNote["FOURTEEN"] = "14";
    HardwareListNote["FIFTEEN"] = "15";
    HardwareListNote["SIXTEEN"] = "16";
    HardwareListNote["SEVENTEEN"] = "17";
    HardwareListNote["EIGHTEEN"] = "18";
    HardwareListNote["NINETEEN"] = "19";
    HardwareListNote["TWENTY"] = "20";
})(HardwareListNote || (HardwareListNote = {}));
export const HardwareListNoteDisplay = new Map([
    [HardwareListNote.ONE, '1. Not Required for Fit checks or Dry Runs.'],
    [HardwareListNote.TWO, '2. To be supplied by Test Director.'],
    [HardwareListNote.THREE, '3. TRR sheets not required.'],
    [
        HardwareListNote.FOUR,
        '4. All TRR information contained in "OBS" sheet. TRR sheet obtained upon initial assignment by life Sciences Project Division. TRR sheets to have "IR-OBS" in block 17.'
    ],
    [
        HardwareListNote.FIVE,
        '5. TRR sheets obtained upon initial receipt in CTSD Bont. TRR sheets to have "IR" in block 17.'
    ],
    [HardwareListNote.SIX, '6. TRR sheet for the SCU/ESCU provided once per test series.'],
    [HardwareListNote.SEVEN, '7. TRR information contained in "PLSS" TRR sheet.'],
    [HardwareListNote.EIGHT, '8. Quality to verify P/"N" & S/"N" at applicable chamber.'],
    [HardwareListNote.NINE, '9. TRR information contained in "HUT" TRR sheets.'],
    [HardwareListNote.TEN, '10. TRR information contained in "Helmet/EVA Assembly" TRR sheets.'],
    [HardwareListNote.ELEVEN, '11. TRR information contained in "LTA" TRR sheets.'],
    [HardwareListNote.TWELVE, '12. TRR information contained in "CAA" TRR sheets.'],
    [HardwareListNote.THIRTEEN, '13. TRR information contained in "LCVG" TRR sheets.'],
    [HardwareListNote.FOURTEEN, '14. TRR information contained in "Glove" TRR sheets.'],
    [HardwareListNote.FIFTEEN, '15. TRR information contained in "Arm Assy." TRR sheets.'],
    [HardwareListNote.SIXTEEN, '16. TRR sheets for this hardware provided once per this test series.'],
    [HardwareListNote.SEVENTEEN, '17. TRR sheets to be provided by Wyle Labs.'],
    [HardwareListNote.EIGHTEEN, '18. Non-serialized items available for use.'],
    [HardwareListNote.NINETEEN, '19. The Metox canister is Prime for the Crew Member.'],
    [
        HardwareListNote.TWENTY,
        '20. This part is not in the EMUHTS(owner of this Hardware List). The information is from the requesting engineer.'
    ]
]);
export const HardwareListTypeDisplay = new Map([
    [HardwareListType.CREWMEMBER, 'Crewmember'],
    [HardwareListType.DELIVERY_MATRIX, 'Delivery Matrix'],
    [HardwareListType.EMU_HARDWARE, 'EMU'],
    [HardwareListType.FLIGHT_SUPPORT_HARDWARE, 'Flight Support'],
    [HardwareListType.GROUND_SUPPORT_EQUIPMENT, 'GSE'],
    [HardwareListType.HARDWARE, 'Hardware'],
    [HardwareListType.TOOLS, 'Tools'],
    [HardwareListType.WORK_ORDER_STEP_HARDWARE, 'Hardware for step'],
    [HardwareListType.WORK_ORDER_STEP_TOOLS, 'Tools for step'],
    [HardwareListType.COSMIC_DOCUMENT_HARDWARE, 'Hardware for Doc'],
    [HardwareListType.COSMIC_DOCUMENT_TOOLS, 'Tools for Doc']
]);
export const CalibrationTypeDisplay = new Map([
    [CalibrationType.ANNUAL_CERTIFICATION, 'Annual certification'],
    [CalibrationType.ANNUAL_LEAKAGE, 'Annual leakage'],
    [CalibrationType.ANNUAL_SAMPLING, 'Annual sampling'],
    [CalibrationType.CALIBRATION, 'Calibration'],
    [CalibrationType.CLASS_I_INSPECTION, 'Class I inspection'],
    [CalibrationType.CLASS_II_INSPECTION, 'Class II inspection'],
    [CalibrationType.CLASS_III_INSPECTION, 'Class III inspection'],
    [CalibrationType.DOT_CERTIFICATION, 'DOT certification'],
    [CalibrationType.FILTER_CHANGE_OUT, 'Filter change out'],
    [CalibrationType.FUNCTIONAL_CHECK_OUT, 'Functional check out'],
    [CalibrationType.GENERAL, 'General'],
    [CalibrationType.H2O_IODINE_TREATMENT, 'Water iodine treatment'],
    [CalibrationType.HYDROSTATIC_TEST, 'Hydrostatic test'],
    [CalibrationType.IN_HOUSE_CALIBRATION, 'In house calibration'],
    [CalibrationType.LOAD_CERTIFICATION, 'Load certification'],
    [CalibrationType.MONTHLY_SAMPLING, 'Monthly sampling'],
    [CalibrationType.PNEUMATIC_TEST, 'Pneumatic test'],
    [CalibrationType.PREVENTATIVE_MAINTENANCE, 'Preventative maintenance'],
    [CalibrationType.PROOF_PRESSURE_TEST, 'Proof pressure test'],
    [CalibrationType.QUARTERLY_CERTIFICATION, 'Quarterly certification'],
    [CalibrationType.RADIATION_SAFETY_CERTIFICATE, 'Radiation safety certificate'],
    [CalibrationType.RELIEF_VALVE_CERTIFICATION, 'Relief valve certification']
]);
export var LimitedLifeCycleField;
(function (LimitedLifeCycleField) {
    LimitedLifeCycleField[LimitedLifeCycleField["FLIGHT"] = LimitedLifeType.FLIGHT] = "FLIGHT";
    LimitedLifeCycleField[LimitedLifeCycleField["CYCLE"] = LimitedLifeType.CYCLE] = "CYCLE";
    LimitedLifeCycleField[LimitedLifeCycleField["EVA"] = LimitedLifeType.EVA] = "EVA";
})(LimitedLifeCycleField || (LimitedLifeCycleField = {}));
export var LimitedLifeIntervalField;
(function (LimitedLifeIntervalField) {
    LimitedLifeIntervalField[LimitedLifeIntervalField["SHELF"] = LimitedLifeType.SHELF] = "SHELF";
    LimitedLifeIntervalField[LimitedLifeIntervalField["USAGE"] = LimitedLifeType.USAGE] = "USAGE";
    LimitedLifeIntervalField[LimitedLifeIntervalField["OPERATION"] = LimitedLifeType.OPERATION] = "OPERATION";
    LimitedLifeIntervalField[LimitedLifeIntervalField["PRESSURIZED_TIME"] = LimitedLifeType.PRESSURIZED_TIME] = "PRESSURIZED_TIME";
    LimitedLifeIntervalField[LimitedLifeIntervalField["INTERVAL"] = LimitedLifeType.INTERVAL] = "INTERVAL";
    LimitedLifeIntervalField[LimitedLifeIntervalField["ON_ORBIT"] = LimitedLifeType.ON_ORBIT] = "ON_ORBIT";
    LimitedLifeIntervalField[LimitedLifeIntervalField["STATIC"] = LimitedLifeType.STATIC] = "STATIC";
})(LimitedLifeIntervalField || (LimitedLifeIntervalField = {}));
// CYCLE ONLY TYPES
export const LimitedLifeCycleFieldDisplay = new Map([
    [LimitedLifeCycleField.FLIGHT, 'Flight life'],
    [LimitedLifeCycleField.CYCLE, 'Cycle / Count life'],
    [LimitedLifeCycleField.EVA, 'EVA life']
]);
// INTERVAL ONLY TYPES
export const LimitedLifeIntervalFieldDisplay = new Map([
    [LimitedLifeIntervalField.SHELF, 'Shelf life'],
    [LimitedLifeIntervalField.USAGE, 'Usage life'],
    [LimitedLifeIntervalField.OPERATION, 'Operational life'],
    [LimitedLifeIntervalField.PRESSURIZED_TIME, 'Pressurized time life'],
    [LimitedLifeIntervalField.INTERVAL, 'Interval life'],
    [LimitedLifeIntervalField.ON_ORBIT, 'On Orbit life'],
    [LimitedLifeIntervalField.STATIC, 'Static life']
]);
// ALL LIMITED LIFE TYPES
export const LimitedLifeTypeDisplay = new Map([
    [LimitedLifeType.CYCLE, 'Cycle life'],
    [LimitedLifeType.EVA, 'EVA life'],
    [LimitedLifeType.FLIGHT, 'Flight life'],
    [LimitedLifeType.INTERVAL, 'Interval life'],
    [LimitedLifeType.ON_ORBIT, 'On Orbit life'],
    [LimitedLifeType.OPERATION, 'Operational life'],
    [LimitedLifeType.PRESSURIZED_TIME, 'Pressurized time life'],
    [LimitedLifeType.SHELF, 'Shelf life'],
    [LimitedLifeType.STATIC, 'Static life'],
    [LimitedLifeType.USAGE, 'Usage life']
]);
export const LimitedLifeTypeShortDisplay = new Map([
    [LimitedLifeType.CYCLE, 'Cycle'],
    [LimitedLifeType.EVA, 'EVA '],
    [LimitedLifeType.FLIGHT, 'Flight'],
    [LimitedLifeType.INTERVAL, 'Interval'],
    [LimitedLifeType.ON_ORBIT, 'On Orbit'],
    [LimitedLifeType.OPERATION, 'Operational'],
    [LimitedLifeType.PRESSURIZED_TIME, 'P time'],
    [LimitedLifeType.SHELF, 'Shelf'],
    [LimitedLifeType.STATIC, 'Static'],
    [LimitedLifeType.USAGE, 'Usage']
]);
export const LimitedLifeTypeToPropertyName = new Map([
    [LimitedLifeType.SHELF, 'shelf'],
    [LimitedLifeType.USAGE, 'usage'],
    [LimitedLifeType.OPERATION, 'operational'],
    [LimitedLifeType.PRESSURIZED_TIME, 'pressurizedTime'],
    [LimitedLifeType.INTERVAL, 'interval'],
    [LimitedLifeType.ON_ORBIT, 'onOrbit'],
    [LimitedLifeType.STATIC, 'static'],
    [LimitedLifeType.FLIGHT, 'flight'],
    [LimitedLifeType.CYCLE, 'cycle'],
    [LimitedLifeType.EVA, 'eva']
]);
// Physical Inventory Audit
export var AuditItemVisibilityToggle;
(function (AuditItemVisibilityToggle) {
    AuditItemVisibilityToggle["ONLY_OPEN"] = "ONLY_OPEN";
    AuditItemVisibilityToggle["ONLY_CLOSED"] = "ONLY_CLOSED";
    AuditItemVisibilityToggle["ONLY_DEVIATIONS"] = "ONLY_DEVIATIONS";
})(AuditItemVisibilityToggle || (AuditItemVisibilityToggle = {}));
export const InventoryControlDisplay = new Map([
    [InventoryControl.SERIAL, 'Serial'],
    [InventoryControl.LOT, 'Lot']
]);
export const InventoryMethodDisplay = new Map([
    [InventoryMethod.ARTICLE, 'Article'],
    [InventoryMethod.BAG, 'Bag'],
    [InventoryMethod.BOTTLE, 'Bottle'],
    [InventoryMethod.BOX, 'Box'],
    [InventoryMethod.BUNDLE, 'Bundle'],
    [InventoryMethod.CAN, 'Can'],
    [InventoryMethod.CARD, 'Card'],
    [InventoryMethod.CARTON, 'Carton'],
    [InventoryMethod.CASE, 'Case'],
    [InventoryMethod.CONTAINER, 'Container'],
    [InventoryMethod.CYLINDER, 'Cylinder'],
    [InventoryMethod.DOZEN, 'Dozen'],
    [InventoryMethod.DRUM, 'Drum'],
    [InventoryMethod.EACH, 'Ea'],
    [InventoryMethod.GROSS, 'Gross'],
    [InventoryMethod.JAR, 'Jar'],
    [InventoryMethod.JOB, 'Job'],
    [InventoryMethod.KIT, 'Kit'],
    [InventoryMethod.LOT, 'Lot'],
    [InventoryMethod.PACKAGE, 'Pkg'],
    [InventoryMethod.PAD, 'Pad'],
    [InventoryMethod.PAGE, 'Page'],
    [InventoryMethod.PAIL, 'Pail'],
    [InventoryMethod.PAIR, 'Pair'],
    [InventoryMethod.PER_THOUSAND, 'per 1000'],
    [InventoryMethod.PIECE, 'Piece'],
    [InventoryMethod.REAM, 'Ream'],
    [InventoryMethod.REEL, 'Reel'],
    [InventoryMethod.ROD, 'Rod'],
    [InventoryMethod.ROLL, 'Roll'],
    [InventoryMethod.SET, 'Set'],
    [InventoryMethod.SHEET, 'Sheet'],
    [InventoryMethod.SPOOL, 'Spool'],
    [InventoryMethod.TUBE, 'Tube'],
    [InventoryMethod.UNIT, 'Unit'],
    [InventoryMethod.VIAL, 'Vial']
]);
export const ReturnableStatusDisplay = new Map([
    [ReturnableStatus.NON_RETURNABLE_INVENTORY, 'No returnable inventory'],
    [ReturnableStatus.RETURNABLE_INVENTORY, 'Has returnable inventory'],
    [ReturnableStatus.RETURNABLE_ITEM_INSTANCE, 'Has returnable instance']
]);
export const InventoryClassDisplay = new Map([
    [InventoryClass.CLASS_I, 'I'],
    [InventoryClass.CLASS_IE, 'IE'],
    [InventoryClass.CLASS_II, 'II'],
    [InventoryClass.CLASS_III, 'III'],
    [InventoryClass.CLASS_IIIC, 'IIIC'],
    [InventoryClass.CLASS_IIIW, 'IIIW'],
    [InventoryClass.COMMERCIAL_OFF_THE_SHELF, 'COMMERCIAL OFF THE SHELF'],
    [InventoryClass.FACILITIES, 'FACILITIES'],
    [InventoryClass.GROUND_SUPPORT_EQUIPMENT, 'GSE'],
    [InventoryClass.PROGRAM_SUPPORT_EQUIPMENT, 'PSE'],
    [InventoryClass.PUBLIC_AFFAIRS_ONLY, 'PAO'],
    [InventoryClass.SPECIAL_TEST_EQUIPMENT, 'STE'],
    [InventoryClass.TEST_SUPPORT_EQUIPMENT, 'TEST SUPPORT EQUIPMENT'],
    [InventoryClass.UC, 'UC'],
    [InventoryClass.UNKNOWN, 'Unknown'],
    [InventoryClass.WORKSITE_INTERFACE_FIXTURE, 'WIF'],
    [InventoryClass._PROTOTYPE, 'PRT']
]);
export const InventoryClassDescriptionDisplay = new Map([
    [InventoryClass._PROTOTYPE, 'Prototype'],
    [InventoryClass.CLASS_I, 'Flight'],
    [InventoryClass.CLASS_IE, 'Inspection equipment / Tools'],
    [InventoryClass.CLASS_II, 'Controlled / Non-flight'],
    [InventoryClass.CLASS_III, 'Uncontrolled / Non-flight'],
    [InventoryClass.CLASS_IIIW, 'Neutral Buoyancy Laboratory (NBL) use, Non-flight'],
    [
        InventoryClass.GROUND_SUPPORT_EQUIPMENT,
        'Controlled / Non-flight / Interfaces with flight hardware during turnaround activities'
    ],
    [InventoryClass.PUBLIC_AFFAIRS_ONLY, 'Public Affairs Office'],
    [InventoryClass.SPECIAL_TEST_EQUIPMENT, 'Special Test Equipment'],
    [InventoryClass.UNKNOWN, 'Unknown']
]);
export var AlternateType;
(function (AlternateType) {
    AlternateType["PREFERRED"] = "PREFERRED";
    AlternateType["ALTERNATE"] = "ALTERNATE";
    AlternateType["TRAINING_PREFERRED"] = "TRAINING_PREFERRED";
    AlternateType["TRAINING_ALTERNATE"] = "TRAINING_ALTERNATE";
})(AlternateType || (AlternateType = {}));
export const AlternateTypeDisplay = new Map([
    [AlternateType.PREFERRED, 'PREFERRED'],
    [AlternateType.ALTERNATE, 'ALTERNATE'],
    [AlternateType.TRAINING_PREFERRED, 'TRAINING PREFERRED'],
    [AlternateType.TRAINING_ALTERNATE, 'TRAINING ALTERNATE']
]);
export var MakeBuySupply;
(function (MakeBuySupply) {
    MakeBuySupply["MAKE"] = "MAKE";
    MakeBuySupply["BUY"] = "BUY";
    MakeBuySupply["SUPPLY"] = "SUPPLY";
})(MakeBuySupply || (MakeBuySupply = {}));
export const ItemMasterMakeBuySupplyDisplay = new Map([
    [MakeBuySupply.MAKE, 'MAKE'],
    [MakeBuySupply.BUY, 'BUY'],
    [MakeBuySupply.SUPPLY, 'SUPPLY']
]);
export var LimitedLifeCodes;
(function (LimitedLifeCodes) {
    LimitedLifeCodes["CYC"] = "CYC";
    LimitedLifeCodes["BOT"] = "BOT";
    LimitedLifeCodes["CCC"] = "CCC";
    LimitedLifeCodes["REG"] = "REG";
    LimitedLifeCodes["SSA"] = "SSA";
    LimitedLifeCodes["BAT"] = "BAT";
    LimitedLifeCodes["FAN"] = "FAN";
    LimitedLifeCodes["CAL"] = "CAL";
})(LimitedLifeCodes || (LimitedLifeCodes = {}));
export const LimitedLifeCodesDisplay = new Map([
    [LimitedLifeCodes.CYC, 'CYC'],
    [LimitedLifeCodes.BOT, 'BOT'],
    [LimitedLifeCodes.CCC, 'CCC'],
    [LimitedLifeCodes.REG, 'REG'],
    [LimitedLifeCodes.SSA, 'SSA'],
    [LimitedLifeCodes.BAT, 'BAT'],
    [LimitedLifeCodes.FAN, 'FAN'],
    [LimitedLifeCodes.CAL, 'CAL']
]);
export const SideDisplay = new Map([
    [Side.LEFT, 'L'],
    [Side.RIGHT, 'R'],
    [Side.NONE, 'n/a']
]);
export const InventoryUnitTypeDisplay = new Map([
    [InventoryUnitType.CENTIMETER, 'Centimeter'],
    [InventoryUnitType.CFU_PER_MILLILITER, 'CFU per milliliter'],
    [InventoryUnitType.CUBIC_FOOT, 'Cubic foot'],
    [InventoryUnitType.CUBIC_INCH, 'Cubic inch'],
    [InventoryUnitType.DAY, 'Day'],
    [InventoryUnitType.DEGREE, 'Degree'],
    [InventoryUnitType.DOZEN, 'Dozen'],
    [InventoryUnitType.FOOT, 'Foot'],
    [InventoryUnitType.GALLON, 'Gallon'],
    [InventoryUnitType.GRAM, 'Gram'],
    [InventoryUnitType.HOUR, 'Hour'],
    [InventoryUnitType.INCH, 'Inch'],
    [InventoryUnitType.KILOGRAM, 'Kilogram'],
    [InventoryUnitType.LITER, 'Liter'],
    [InventoryUnitType.METER, 'Meter'],
    [InventoryUnitType.MICRO_SEMENS_PER_CENTIMETER, 'Micro semens per centimeter'],
    [InventoryUnitType.MILLILITER, 'Milliliter'],
    [InventoryUnitType.MILLIMETER, 'Millimeter'],
    [InventoryUnitType.MINUTE, 'Minute'],
    [InventoryUnitType.MONTH, 'Month'],
    [InventoryUnitType.OUNCE, 'Ounce'],
    [InventoryUnitType.PARTS_PER_BILLION, 'Parts perbillion'],
    [InventoryUnitType.PH, 'Ph'],
    [InventoryUnitType.PINT, 'Pint'],
    [InventoryUnitType.POUND, 'Pound'],
    [InventoryUnitType.QUART, 'Quart'],
    [InventoryUnitType.RADIAN, 'Radian'],
    [InventoryUnitType.SECOND, 'Second'],
    [InventoryUnitType.SHOE_US, 'Shoe US'],
    [InventoryUnitType.SQUARE_FOOT, 'Square foot'],
    [InventoryUnitType.SQUARE_INCH, 'Square inch'],
    [InventoryUnitType.SQUARE_METER, 'Square meter'],
    [InventoryUnitType.SQUARE_YARD, 'Square yard'],
    [InventoryUnitType.YARD, 'Yard'],
    [InventoryUnitType.YEAR, 'Year']
]);
// converts InventoryUnitType's to their appropriate abbreviations
export const InventoryUnitTypeAbbreviationDisplay = new Map([
    [InventoryUnitType.CENTIMETER, 'cm'],
    [InventoryUnitType.CFU_PER_MILLILITER, 'CFU/mL'],
    [InventoryUnitType.CUBIC_FOOT, 'ft³'],
    [InventoryUnitType.CUBIC_INCH, 'cu³'],
    [InventoryUnitType.DAY, 'd'],
    [InventoryUnitType.DEGREE, 'deg'],
    [InventoryUnitType.DOZEN, 'doz'],
    [InventoryUnitType.FOOT, 'ft'],
    [InventoryUnitType.GALLON, 'gal'],
    [InventoryUnitType.GRAM, 'gm'],
    [InventoryUnitType.HOUR, 'hrs'],
    [InventoryUnitType.INCH, 'in'],
    [InventoryUnitType.KILOGRAM, 'kg'],
    [InventoryUnitType.LITER, 'ltr'],
    [InventoryUnitType.METER, 'm'],
    [InventoryUnitType.MICRO_SEMENS_PER_CENTIMETER, 'µS/cm'],
    [InventoryUnitType.MILLILITER, 'ml'],
    [InventoryUnitType.MILLIMETER, 'mm'],
    [InventoryUnitType.MINUTE, 'min'],
    [InventoryUnitType.MONTH, 'mo'],
    [InventoryUnitType.OUNCE, 'oz'],
    [InventoryUnitType.PARTS_PER_BILLION, 'ppb'],
    [InventoryUnitType.PH, 'ph'],
    [InventoryUnitType.PINT, 'pt'],
    [InventoryUnitType.POUND, 'lb'],
    [InventoryUnitType.QUART, 'qt'],
    [InventoryUnitType.RADIAN, 'rad'],
    [InventoryUnitType.SECOND, 'sec'],
    [InventoryUnitType.SHOE_US, 'shoe'],
    [InventoryUnitType.SQUARE_FOOT, 'ft²'],
    [InventoryUnitType.SQUARE_INCH, 'in²'],
    [InventoryUnitType.SQUARE_METER, 'm²'],
    [InventoryUnitType.SQUARE_YARD, 'yd²'],
    [InventoryUnitType.YARD, 'yd'],
    [InventoryUnitType.YEAR, 'yr']
]);
export const ItemMasterPropertyClassDisplay = new Map([
    [ItemMasterPropertyClass.BUILDINGS, 'Buildings'],
    [ItemMasterPropertyClass.COMPUTER_SOFTWARE, 'Computer software'],
    [ItemMasterPropertyClass.LAND, 'Land'],
    [ItemMasterPropertyClass.MATERIAL, 'Material'],
    [ItemMasterPropertyClass.NEEDS_ASSIGNMENT, 'Needs assignment'],
    [ItemMasterPropertyClass.OTHER_STRUCTURES, 'Other structures'],
    [ItemMasterPropertyClass.PLANT_EQUIPMENT, 'Plant equipment'],
    [ItemMasterPropertyClass.SENSITIVE_EQUIPMENT, 'Sensitive equipment'],
    [ItemMasterPropertyClass.SERVICE_MAINTENANCE, 'Service/maintenance'],
    [ItemMasterPropertyClass.SPACE_HARDWARE_APP, 'Space Hardware/APP'],
    [ItemMasterPropertyClass.SPECIAL_TEST_EQUIPMENT, 'Special test equipment'],
    [ItemMasterPropertyClass.SPECIAL_TOOLING, 'Special tooling']
]);
export var StockUnit;
(function (StockUnit) {
    StockUnit["BAG"] = "BAG";
    StockUnit["BOTTLE"] = "BOTTLE";
    StockUnit["BOX"] = "BOX";
    StockUnit["BUNDLE"] = "BUNDLE";
    StockUnit["CAN"] = "CAN";
    StockUnit["CARD"] = "CARD";
    StockUnit["CARTON"] = "CARTON";
    StockUnit["CASE"] = "CASE";
    StockUnit["CYLINDER"] = "CYLINDER";
    StockUnit["DOZEN"] = "DOZEN";
    StockUnit["EACH"] = "EACH";
    StockUnit["FOOT"] = "FOOT";
    StockUnit["GALLON"] = "GALLON";
    StockUnit["GRAM"] = "GRAM";
    StockUnit["INCH"] = "INCH";
    StockUnit["JAR"] = "JAR";
    StockUnit["JOB"] = "JOB";
    StockUnit["KILOGRAM"] = "KILOGRAM";
    StockUnit["KIT"] = "KIT";
    StockUnit["LITER"] = "LITER";
    StockUnit["LOT"] = "LOT";
    StockUnit["MONTH"] = "MONTH";
    StockUnit["PACKAGE"] = "PACKAGE";
    StockUnit["PAIR"] = "PAIR";
    StockUnit["PINT"] = "PINT";
    StockUnit["POUND"] = "POUND";
    StockUnit["QUART"] = "QUART";
    StockUnit["REAM"] = "REAM";
    StockUnit["REEL"] = "REEL";
    StockUnit["ROLL"] = "ROLL";
    StockUnit["SET"] = "SET";
    StockUnit["SHEET"] = "SHEET";
    StockUnit["SPOOL"] = "SPOOL";
    StockUnit["SQUARE_FOOT"] = "SQUARE_FOOT";
    StockUnit["SQUARE_INCH"] = "SQUARE_INCH";
    StockUnit["TUBE"] = "TUBE";
    StockUnit["UNIT"] = "UNIT";
    StockUnit["YARD"] = "YARD";
    StockUnit["YEAR"] = "YEAR";
})(StockUnit || (StockUnit = {}));
export const StockUnitDisplay = new Map([
    [StockUnit.BAG, 'Bag'],
    [StockUnit.BOTTLE, 'Bottle'],
    [StockUnit.BOX, 'Box'],
    [StockUnit.BUNDLE, 'Bundle'],
    [StockUnit.CAN, 'Can'],
    [StockUnit.CARD, 'Card'],
    [StockUnit.CARTON, 'Carton'],
    [StockUnit.CASE, 'Case'],
    [StockUnit.CYLINDER, 'Cylinder'],
    [StockUnit.DOZEN, 'Dozen'],
    [StockUnit.EACH, 'Each'],
    [StockUnit.FOOT, 'Foot'],
    [StockUnit.GALLON, 'Gallon'],
    [StockUnit.GRAM, 'Gram'],
    [StockUnit.INCH, 'Inch'],
    [StockUnit.JAR, 'Jar'],
    [StockUnit.JOB, 'Job'],
    [StockUnit.KILOGRAM, 'Kilogram'],
    [StockUnit.KIT, 'Kit'],
    [StockUnit.LITER, 'Liter'],
    [StockUnit.LOT, 'Lot'],
    [StockUnit.MONTH, 'Month'],
    [StockUnit.PACKAGE, 'Package'],
    [StockUnit.PAIR, 'Pair'],
    [StockUnit.PINT, 'Pint'],
    [StockUnit.POUND, 'Pound'],
    [StockUnit.QUART, 'Quart'],
    [StockUnit.REAM, 'Ream'],
    [StockUnit.REEL, 'Reel'],
    [StockUnit.ROLL, 'Roll'],
    [StockUnit.SET, 'Set'],
    [StockUnit.SHEET, 'Sheet'],
    [StockUnit.SPOOL, 'Spool'],
    [StockUnit.SQUARE_FOOT, 'Square foot'],
    [StockUnit.SQUARE_INCH, 'Square inch'],
    [StockUnit.TUBE, 'Tube'],
    [StockUnit.UNIT, 'Unit'],
    [StockUnit.YARD, 'Yard'],
    [StockUnit.YEAR, 'Year']
]);
